import React, { useEffect, useState } from 'react'

import { Checkbox, Flex, InlineButton } from '@driftt/dds'

import { trackEvent } from 'utils/tracking'

import { SalesRepRows } from '../types'

interface CheckboxFiltersProps {
  tableData: SalesRepRows[]
  setFilteredData: (filteredData: SalesRepRows[]) => void
  isTeamSelected: boolean
}

const checkboxOptions = [
  { name: 'teamAssigned', label: 'Team' },
  { name: 'fullName', label: 'Name' },
  { name: 'profilePhoto', label: 'Profile Photo' },
  { name: 'notificationSettings', label: 'Notifications' },
  { name: 'connectedCalendar', label: 'Calendar' },
  { name: 'conferenceLink', label: 'Conference Link' },
]

const CheckboxFilters = ({
  tableData,
  setFilteredData,
  isTeamSelected,
}: CheckboxFiltersProps) => {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(
    checkboxOptions.reduce((options, { name }) => {
      options[name] = true
      return options
    }, {} as Record<string, boolean>)
  )

  const handleCheckboxChange = (checked, name) => {
    trackEvent('SALES_REP_TABLE_CHECKBOX_CHANGED', {
      name: name,
      value: checked,
    })
    setSelectedCheckboxes((prevState) => ({
      ...prevState,
      [name]: checked,
    }))
  }

  useEffect(() => {
    const filteredData = tableData.filter((item) => {
      const status = item.status
      return (
        (!status.profilePhoto && selectedCheckboxes.profilePhoto) ||
        (!status.teamAssigned && selectedCheckboxes.teamAssigned) ||
        (!status.conferenceLink && selectedCheckboxes.conferenceLink) ||
        (!status.fullName && selectedCheckboxes.fullName) ||
        (!status.connectedCalendar && selectedCheckboxes.connectedCalendar) ||
        (!status.notificationSettings &&
          selectedCheckboxes.notificationSettings)
      )
    })
    setFilteredData(filteredData)
  }, [tableData, selectedCheckboxes, setFilteredData])

  const noneSelected =
    Object.values(selectedCheckboxes).filter((value) => !!value).length === 0

  const handleAllSelection = () => {
    trackEvent('SALES_REP_TABLE_ALL_CHECKBOXES_CHANGED', {
      value: noneSelected,
    })
    setSelectedCheckboxes(
      checkboxOptions.reduce((options, { name }) => {
        options[name] = noneSelected
        return options
      }, {})
    )
  }

  return (
    <Flex gap={2} alignItems="center">
      {checkboxOptions.map((option) => (
        <Checkbox
          key={option.name}
          label={option.label}
          disabled={isTeamSelected && option.name === 'teamAssigned'}
          checked={
            option.name === 'teamAssigned'
              ? !isTeamSelected && selectedCheckboxes[option.name]
              : selectedCheckboxes[option.name]
          }
          onChange={(e) => handleCheckboxChange(e, option.name)}
        />
      ))}
      <InlineButton onClick={handleAllSelection}>
        {noneSelected ? 'Select all' : 'Unselect all'}
      </InlineButton>
    </Flex>
  )
}

export default CheckboxFilters
